import { Route, Routes } from 'react-router-dom'
import Home from './containers/Home'
import Profile from './containers/profile/profile'
import Users from './containers/users/'
import NotFound from './containers/NotFound'
import Login from './containers/login/login'
import NoPermissions from './containers/NoPermissions'
import AuthenticatedRoute from './components/AuthenticatedRoute'
import UnauthenticatedRoute from './components/UnauthenticatedRoute'

export default ({ childProps }: { childProps: any }) => (
  <Routes>
    <Route
      path="/"
      element={
        <AuthenticatedRoute {...childProps}>
          <Home />
        </AuthenticatedRoute>
      }
    />
    <Route
      path="/users"
      element={
        <AuthenticatedRoute {...childProps}>
          <Users />
        </AuthenticatedRoute>
      }
    />
    <Route
      path="/fullscreen"
      element={
        <AuthenticatedRoute {...childProps}>
          <Home />
        </AuthenticatedRoute>
      }
    />
    <Route
      path="/profile"
      element={
        <AuthenticatedRoute {...childProps}>
          <Profile />
        </AuthenticatedRoute>
      }
    />
    <Route
      path="/login"
      element={
        <UnauthenticatedRoute {...childProps}>
          <Login />
        </UnauthenticatedRoute>
      }
    />
    <Route path="/no-permissions" element={<NoPermissions />} />
    {/* Finally, catch all unmatched routes */}
    <Route path="*" element={<NotFound />} />
  </Routes>
)
